var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditNameHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_edit_name_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_edit_name_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4609375
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_edit",
    transform: "translate(2.000000, 2.000000)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33333333,9.47947044 L2.33333333,11.6666667 L4.52052956,11.6666667 L10.9713003,5.21589594 L8.78410406,3.02869972 L2.33333333,9.47947044 L2.33333333,9.47947044 Z M12.662732,3.52446419 C12.8902004,3.29699579 12.8902004,2.92954682 12.662732,2.70207842 L11.2979216,1.33726797 C11.0704532,1.10979956 10.7030042,1.10979956 10.4755358,1.33726797 L9.40818405,2.40461973 L11.5953803,4.59181595 L12.662732,3.52446419 L12.662732,3.52446419 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333333,9.47947044 L2.33333333,11.6666667 L4.52052956,11.6666667 L10.9713003,5.21589594 L8.78410406,3.02869972 L2.33333333,9.47947044 L2.33333333,9.47947044 Z M12.662732,3.52446419 C12.8902004,3.29699579 12.8902004,2.92954682 12.662732,2.70207842 L11.2979216,1.33726797 C11.0704532,1.10979956 10.7030042,1.10979956 10.4755358,1.33726797 L9.40818405,2.40461973 L11.5953803,4.59181595 L12.662732,3.52446419 L12.662732,3.52446419 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditNameHover);
export default __webpack_public_path__ + "static/media/icon_edit_name_hover.032e8402e7ea7272d3187c4eac309acf.svg";
export { ForwardRef as ReactComponent };